import { useQuery } from 'react-query'
import { getInvoicingProgress } from './api'

export const useInvoicingProgress = () => {
  return useQuery({
    queryKey: ['invoicingProgress'],
    queryFn: getInvoicingProgress
  })
}
